var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "refBlockChain", staticClass: "blockChain" },
    [
      _vm._m(0),
      _c("div", { staticClass: "tem-box" }, [
        _c("ul", { staticClass: "bl-ul" }, [
          _c("li", { staticClass: "on" }, [_vm._v("文件验证")]),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.openNewWindow("https://www.ebaoquan.org/query")
                }
              }
            },
            [_vm._v("\n        保全验证\n      ")]
          )
        ]),
        _c("div", { staticClass: "box wb-box" }, [
          _c("img", {
            staticStyle: { width: "563px", "margin-top": "70px" },
            attrs: { src: "/images/blockChain/file-bg1.png" }
          }),
          _c("div", { staticClass: "up-box" }, [
            _vm._m(1),
            _c("div", { staticStyle: { display: "inline-block" } }, [
              !_vm.isHasUpload
                ? _c(
                    "div",
                    {
                      staticClass: "upload-box upl",
                      on: { click: _vm.clickInputFile }
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _c("p", [_vm._v("上传pdf格式文件")])
                    ]
                  )
                : _vm._e(),
              _vm.isHasUpload
                ? _c("div", { staticClass: "upload-box" }, [
                    _c("img", {
                      staticStyle: { width: "50px" },
                      attrs: { src: "/images/blockChain/pdf.png" }
                    }),
                    _c("h1", { on: { click: _vm.clickInputFile } }, [
                      _vm._v("重新上传")
                    ])
                  ])
                : _vm._e(),
              _c("input", {
                ref: "uploadFile",
                staticStyle: { display: "none" },
                attrs: { type: "file" },
                on: { change: _vm.changeFile }
              })
            ]),
            _c(
              "p",
              { staticClass: "no-signinfo" },
              [
                _vm.isNoSignInfo
                  ? [
                      _c("img", {
                        staticStyle: {
                          width: "12px",
                          height: "12px",
                          "margin-right": "10px"
                        },
                        attrs: { src: "/images/blockChain/icon-warn.png" }
                      }),
                      _vm._v("合同没有签名信息\n          ")
                    ]
                  : _vm._e()
              ],
              2
            ),
            _c("div", { staticClass: "textb" }, [
              _c("h1", [
                _c("span", { staticClass: "ff" }, [_vm._v("方法二：")]),
                _vm._v(
                  "使用Adobe Reader\n            PDF阅读器验证电子合同的有效性\n            "
                ),
                _c("p", [
                  _vm._v(
                    "\n              由于Adobe Reader属于国际型应用，国内CA机构颁发的证书不在Adobe\n              Reader的证书信任链接中，同时由于君子签的电子签名使用的是国内CA颁发的CA证书，所以使用AdobeReader进行电子签名有效性验证的时候需要先将国内CA的证书导入到Adobe\n              Reader的信任链接中。\n            "
                  )
                ]),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.specificDialogVisible = true
                      }
                    }
                  },
                  [_vm._v("点击查看具体步骤>>")]
                )
              ])
            ])
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "com-dialog ym",
          attrs: {
            top: "10vh",
            title: "易保全节点查询",
            "close-on-click-modal": false,
            visible: _vm.ybqDialogVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.ybqDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "a-top" },
                [
                  _c("el-input", {
                    staticStyle: { width: "430px", "margin-right": "5px" },
                    attrs: {
                      input: _vm.certificateCheck(_vm.certificateNo),
                      placeholder: "输入备案号",
                      clearable: ""
                    },
                    model: {
                      value: _vm.certificateNo,
                      callback: function($$v) {
                        _vm.certificateNo = $$v
                      },
                      expression: "certificateNo"
                    }
                  }),
                  _c(
                    "el-input",
                    {
                      ref: "imgAuthInput",
                      staticStyle: {
                        width: "240px",
                        position: "relative",
                        "margin-right": "20px"
                      },
                      attrs: {
                        maxlength: "4",
                        clearable: "",
                        "auto-complete": "off",
                        placeholder: "验证码"
                      },
                      model: {
                        value: _vm.imgAuth,
                        callback: function($$v) {
                          _vm.imgAuth = $$v
                        },
                        expression: "imgAuth"
                      }
                    },
                    [
                      _c("template", { slot: "append" }, [
                        _c("div", { on: { click: _vm.getImgAuth } }, [
                          _c("img", {
                            attrs: {
                              src: "data:image/jpeg;base64," + _vm.imgPath
                            }
                          })
                        ])
                      ])
                    ],
                    2
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "90px",
                        background: "#ec1c1c",
                        color: "#ffffff"
                      },
                      on: { click: _vm.blockQuery }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "14px",
                          height: "14px",
                          "margin-right": "10px"
                        },
                        attrs: {
                          src: require("../../static/images/blockChain/query.png")
                        }
                      }),
                      _vm._v("查询\n        ")
                    ]
                  )
                ],
                1
              ),
              _vm.hint
                ? _c(
                    "span",
                    { staticStyle: { color: "#ec1c1c", "font-size": "14px" } },
                    [_vm._v("存证备案号只能是数字")]
                  )
                : _vm._e(),
              _vm.recordNo
                ? [
                    _c(
                      "div",
                      { staticClass: "blockInfo" },
                      [
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("保全备案号:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(
                                _vm._s(_vm._f("leftPad")(_vm.recordNo, 10, "0"))
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("保全主体名称:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(_vm._s(_vm.subjectName))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("保全主体证件:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(_vm._s(_vm.subjectCard))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("操作用户名称:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(_vm._s(_vm.userName))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("操作用户证件:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(_vm._s(_vm.userCard))
                            ])
                          ],
                          1
                        ),
                        _c("el-row", {
                          staticStyle: {
                            height: "1px",
                            border: "1px solid #e4e4e4",
                            margin: "10px 0"
                          }
                        }),
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("保全时间戳:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(
                                _vm._s(_vm._f("formatDateTime2")(_vm.timestamp))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "blockInfo" },
                      [
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("保全文件Hash:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(_vm._s(_vm.sha512Hash))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("易保全链交易Hash:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(_vm._s(_vm.transactionHash))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("易保全链区块Hash:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(_vm._s(_vm.blockHash))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "info" },
                          [
                            _c("el-col", { staticClass: "infoTitle" }, [
                              _vm._v("工信部标识解析:")
                            ]),
                            _c("el-col", { staticClass: "infoValue" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.humiId || "数据同步需要时间，请稍后再查"
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : [
                    _c("div", { staticStyle: { padding: "80px 0 65px" } }, [
                      _c("img", {
                        staticStyle: {
                          width: "440px",
                          height: "250px",
                          margin: "0 auto",
                          display: "block"
                        },
                        attrs: {
                          src: require("../../static/images/blockChain/noData.png")
                        }
                      }),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            color: "rgba(41, 2, 2, 0.65)",
                            "text-align": "center"
                          }
                        },
                        [
                          _vm._v(
                            "\n            暂无结果，请输入存证备案号进行查询\n          "
                          )
                        ]
                      )
                    ])
                  ]
            ],
            2
          ),
          _c(
            "el-row",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.ybqDialogVisible = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "com-dialog ym",
          attrs: {
            top: "10vh",
            title: "互联网法院节点查询",
            "close-on-click-modal": false,
            visible: _vm.internetDialogVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.internetDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "con-box" }, [
            _c("h1", { staticStyle: { "margin-bottom": "10px" } }, [
              _vm._v("查询指南")
            ]),
            _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
              _vm._v(
                "\n        由于互联网法院的特殊性，需按以下步骤查询：\n      "
              )
            ]),
            _c("p", { staticClass: "stp-wrap" }, [
              _c("span", { staticClass: "stp" }, [_vm._v("1")]),
              _vm._v(
                "先通过证据编号在其他区块链节点查询到互联网法院证据编号；\n      "
              )
            ]),
            _c("div", { staticClass: "img-wrap" }, [
              _c("img", {
                attrs: { src: "/images/blockChain/inter-step1.png" }
              })
            ]),
            _c("p", { staticClass: "stp-wrap" }, [
              _c("span", { staticClass: "stp" }, [_vm._v("2")]),
              _vm._v("得到互联网法院证据编号后，登录互联网法院："),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.gzinternetcourt.gov.cn",
                    target: "_blank"
                  }
                },
                [_vm._v("www .gzinternetcourt.gov.cn")]
              ),
              _vm._v(
                "\n        ，在添加证据时选择可信电子凭证平台，输入相应证据编号即可验证。\n      "
              )
            ]),
            _c("div", { staticClass: "img-wrap" }, [
              _c("img", {
                attrs: { src: "/images/blockChain/inter-step2.png" }
              })
            ])
          ]),
          _c(
            "el-row",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.internetDialogVisible = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "com-dialog notK",
          attrs: {
            top: "10vh",
            title: "提示",
            "close-on-click-modal": false,
            visible: _vm.notKDialogVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.notKDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "notk-box" }, [
            _c("img", { attrs: { src: "/images/blockChain/expect.png" } }),
            _c(
              "span",
              { staticStyle: { display: "inline-block", width: "196px" } },
              [_vm._v("该节点线上查询功能暂未开通， 敬请期待！")]
            )
          ]),
          _c(
            "el-row",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.notKDialogVisible = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "com-dialog ym",
          attrs: {
            top: "10vh",
            title: "方法二具体步骤",
            "close-on-click-modal": false,
            visible: _vm.specificDialogVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.specificDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "con-box" }, [
            _c(
              "p",
              {
                staticClass: "stp-wrap",
                staticStyle: { "margin-bottom": "20px" }
              },
              [
                _c("span", { staticClass: "stp" }, [_vm._v("1")]),
                _vm._v(
                  "在您的电脑上安装Adobe Reader\n        PDF阅读器（若已安装，直接进行第二步操作） 您可以登录Adobe\n        Reader的官方软件下载此软件。官方下载链接为："
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://acrobat.adobe.com/cn/zh-Hans/acrobat/pdf-reader.html",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      "https://acrobat.adobe .com/cn/zh-Hans/acrobat/pdf-reader.html"
                    )
                  ]
                )
              ]
            ),
            _c("p", { staticClass: "stp-wrap" }, [
              _c("span", { staticClass: "stp" }, [_vm._v("2")]),
              _vm._v(
                "验证电子签名合同：使用Adobe Reader\n        PDF阅读器打开需要验证的文档，找到合同中的电子签章后，点击电子签章，即可查看电子签章的有效性，如下图所示：\n      "
              )
            ]),
            _c(
              "div",
              {
                staticClass: "img-wrap",
                staticStyle: { "text-align": "left" }
              },
              [
                _c("img", {
                  staticStyle: {
                    width: "388px",
                    height: "auto",
                    display: "inline-block"
                  },
                  attrs: { src: "/images/blockChain/fileVerify-step1.png" }
                })
              ]
            ),
            _c("p", { staticClass: "stp-wrap" }, [
              _vm._v(
                "\n        点击“签名属性”按钮，可以查看该电子签名的其他有效信息，如下图所示：\n      "
              )
            ]),
            _c("div", { staticClass: "img-wrap" }, [
              _c("img", {
                staticStyle: {
                  width: "370px",
                  display: "inline-block",
                  "margin-right": "20px"
                },
                attrs: { src: "/images/blockChain/fileVerify-step2.png" }
              }),
              _c("img", {
                staticStyle: {
                  width: "370px",
                  display: "inline-block",
                  "vertical-align": "top"
                },
                attrs: { src: "/images/blockChain/fileVerify-step3.png" }
              })
            ])
          ]),
          _c(
            "el-row",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.specificDialogVisible = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "com-dialog ym",
          attrs: {
            top: "10vh",
            title: "查询结果",
            "close-on-click-modal": false,
            visible: _vm.searchResultVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.searchResultVisible = $event
            }
          }
        },
        [
          _c("div", {
            staticClass: "con-box",
            domProps: { innerHTML: _vm._s(_vm.searchInfo) }
          })
        ]
      ),
      _c("a", { attrs: { href: "https://dms.citln.cn/" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "chain-title" }, [
      _c("img", { attrs: { src: "/images/blockChain/lbg.png" } }),
      _vm._v("文件/保全验证\n    "),
      _c("img", {
        staticStyle: { transform: "rotate(180deg)" },
        attrs: { src: "/images/blockChain/lbg.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "textb" }, [
      _c("h1", [
        _c("span", { staticClass: "ff" }, [_vm._v("方法一：")]),
        _vm._v(
          "点击下方的（上传PDF文件效验）按钮上传需要验证的文档\n            "
        ),
        _c("p", [
          _vm._v("将已完成状态的合同文件上传，系统将进行电子合同有效性验证")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57941ba0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57941ba0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/blockChain/index.vue
// module id = aikc
// module chunks = 10